import { useState } from 'react';
import { RouteDetailsTableProps } from '../../../../../sp-types/routeDetailsType';
import React from 'react';

export const InputRouteDetailsTable: React.FC<RouteDetailsTableProps> = ({ columns, rowsData, update = () => {} }) => {
  const [currentColumns, setCurrentColumns] = useState(columns);
  const [currentRows, setCurrentRows] = useState(rowsData);

  const handleColumnChange = (index: number, value: string) => {
    const updatedColumns = [...currentColumns];
    updatedColumns[index] = value;
    setCurrentColumns(updatedColumns);
    update({ columns: updatedColumns, rowsData: currentRows });
  };

  const handleCellChange = (rowIndex: number, columnKey: string, value: string) => {
    const updatedRows = currentRows.map((row, idx) => (idx === rowIndex ? { ...row, [columnKey]: value } : row));
    setCurrentRows(updatedRows);
    update({ columns: currentColumns, rowsData: updatedRows });
  };

  const handleAddColumn = () => {
    const newColumn = `Column ${currentColumns.length + 1}`;
    const updatedColumns = [...currentColumns, newColumn];
    const updatedRows = currentRows.map((row) => ({ ...row, [newColumn]: '' }));
    setCurrentColumns(updatedColumns);
    setCurrentRows(updatedRows);
    update({ columns: updatedColumns, rowsData: updatedRows });
  };

  const handleAddRow = () => {
    const newRow = currentColumns.reduce((acc, column) => ({ ...acc, [column]: '' }), {} as Record<string, string>);
    const updatedRows = [...currentRows, newRow];
    setCurrentRows(updatedRows);
    update({ columns: currentColumns, rowsData: updatedRows });
  };

  const handleDeleteColumn = (index: number) => {
    const updatedColumns = currentColumns.filter((_, idx) => idx !== index);
    const updatedRows = currentRows.map((row) => {
      const newRow = { ...row };
      delete newRow[currentColumns[index]];
      return newRow;
    });
    setCurrentColumns(updatedColumns);
    setCurrentRows(updatedRows);
    update({ columns: updatedColumns, rowsData: updatedRows });
  };

  const handleDeleteRow = (index: number) => {
    const updatedRows = currentRows.filter((_, idx) => idx !== index);
    setCurrentRows(updatedRows);
    update({ columns: currentColumns, rowsData: updatedRows });
  };

  return (
    <div className="flex flex-row gap-3 overflow-x-auto ">
      <table className=" divide-y divide-gray-200 border bg-gray-50">
        <thead className="bg-gray-50">
          <tr>
            {currentColumns.map((column, index) => (
              <th key={index} className="text-left text-xs p-2">
                <div className="flex items-center">
                  <input
                    type="text"
                    value={column}
                    onChange={(e) => handleColumnChange(index, e.target.value)}
                    className="w-full bg-gray-50 "
                    placeholder="Column Name"
                  />
                  <button className="text-red-500" onClick={() => handleDeleteColumn(index)}>
                    X
                  </button>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {currentRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {currentColumns.map((column, cellIndex) => (
                <td key={cellIndex} className="text-sm whitespace-nowrap p-2 border">
                  <input
                    type="text"
                    value={row[column]}
                    onChange={(e) => handleCellChange(rowIndex, column, e.target.value)}
                    className="w-full"
                    placeholder="Value"
                  />
                </td>
              ))}
              <td className="text-sm whitespace-nowrap p-2 border">
                <button className="text-red-500 text-sm" onClick={() => handleDeleteRow(rowIndex)}>
                  X
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex flex-col gap-3 bg-gray-50 rounded-md p-2  ">
        <p className="text-sm text-center border-b ">Add</p>
        <button className="p-1 border rounded text-sm bg-white" onClick={handleAddColumn}>
          Column
        </button>
        <button className="p-1 border rounded text-sm bg-white" onClick={handleAddRow}>
          Row
        </button>
      </div>
    </div>
  );
};
